<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<!-- =========================================================
     PICKER VIEW — pick which system's roles to manage
     ========================================================= -->
<ng-container *ngIf="!selectedCard">
  <section class="picker-hero">
    <div class="picker-hero-bg"></div>
    <div class="picker-hero-content">
      <div class="eyebrow">
        <i class="pi pi-id-card"></i>
        <span>إدارة الأدوار</span>
      </div>
      <h1 class="title">{{ 'ROLES.TITLE' | translate }}</h1>
      <p class="sub">
        اختر نظاماً لإدارة أدواره. كل نظام يحتوي على أدواره وصلاحياته بشكل مستقل،
        وأدوار «SuperAdmin» تُدار حصراً من صفحة <code>System Owner</code>.
      </p>
    </div>
  </section>

  <div class="picker-skeleton" *ngIf="loading">
    <div class="sys-skel" *ngFor="let i of [1,2,3,4,5,6]"></div>
  </div>

  <div class="systems-grid" *ngIf="!loading">
    <button
      type="button"
      class="sys-card"
      [class]="card.themeClass"
      [class.is-empty]="card.total === 0"
      *ngFor="let card of systemCards; trackBy: trackCard"
      (click)="selectCard(card)"
    >
      <div class="sys-card-head">
        <div class="sys-icon">
          <i [class]="card.icon"></i>
        </div>
        <div class="sys-meta">
          <h3 class="sys-name">{{ card.displayName }}</h3>
          <code class="sys-key" *ngIf="!card.isGlobal">{{ card.key }}</code>
          <span class="global-tag" *ngIf="card.isGlobal">يشمل كل الأنظمة</span>
        </div>
      </div>

      <div class="sys-stats">
        <div class="sys-stat">
          <span class="num">{{ card.total }}</span>
          <span class="lbl">دور</span>
        </div>
        <span class="dot" aria-hidden="true" *ngIf="card.superAdmins > 0"></span>
        <div class="sys-stat sys-stat--accent" *ngIf="card.superAdmins > 0">
          <span class="num">{{ card.superAdmins }}</span>
          <span class="lbl">SuperAdmin</span>
        </div>
        <span class="dot" aria-hidden="true" *ngIf="card.totalPermissions > 0"></span>
        <div class="sys-stat" *ngIf="card.totalPermissions > 0">
          <span class="num">{{ card.totalPermissions }}</span>
          <span class="lbl">صلاحية</span>
        </div>
      </div>

      <div class="sys-resources" *ngIf="card.topRoleNames.length > 0">
        <span class="res-pill" *ngFor="let name of card.topRoleNames" [title]="name">{{ name }}</span>
      </div>

      <div class="sys-empty" *ngIf="card.total === 0">
        <i class="pi pi-inbox"></i>
        <span>لا توجد أدوار</span>
      </div>

      <div class="sys-cta">
        <span>{{ card.total === 0 ? 'أضف أدواراً' : 'إدارة الأدوار' }}</span>
        <i class="pi pi-arrow-left"></i>
      </div>
    </button>

    <div class="picker-empty" *ngIf="systemCards.length === 0">
      <div class="empty-illust"><i class="pi pi-th-large"></i></div>
      <h3>لا توجد أنظمة متاحة</h3>
      <p>تواصل مع مالك النظام لإسناد وصول لك على أحد الأنظمة.</p>
    </div>
  </div>
</ng-container>

<!-- =========================================================
     DETAIL VIEW — roles within selected system
     ========================================================= -->
<ng-container *ngIf="selectedCard">
  <section class="detail-hero">
    <button type="button" class="back-btn" (click)="backToPicker()">
      <i class="pi pi-arrow-right"></i>
      <span>كل الأنظمة</span>
    </button>

    <div class="detail-hero-main">
      <div class="detail-icon" [class]="selectedCard.themeClass">
        <i [class]="selectedCard.icon"></i>
      </div>
      <div class="detail-text">
        <div class="eyebrow eyebrow-light">
          <i class="pi pi-id-card"></i>
          <span>أدوار النظام</span>
        </div>
        <h1 class="detail-title">{{ selectedCard.displayName }}</h1>
        <code class="detail-key" *ngIf="!selectedCard.isGlobal">{{ selectedCard.key }}</code>
      </div>
    </div>

    <div class="detail-stats">
      <div class="d-stat">
        <span class="d-stat-num">{{ detailRoles.length }}</span>
        <span class="d-stat-lbl">دور</span>
      </div>
      <div class="d-stat d-stat--accent" *ngIf="selectedCard.superAdmins > 0">
        <span class="d-stat-num">{{ selectedCard.superAdmins }}</span>
        <span class="d-stat-lbl">SuperAdmin</span>
      </div>
      <div class="d-stat d-stat--info" *ngIf="selectedCard.totalPermissions > 0">
        <span class="d-stat-num">{{ selectedCard.totalPermissions }}</span>
        <span class="d-stat-lbl">صلاحية</span>
      </div>
    </div>
  </section>

  <div class="detail-toolbar">
    <span class="p-input-icon-left search-wrap">
      <i class="pi pi-search"></i>
      <input
        pInputText
        [(ngModel)]="search"
        placeholder="ابحث عن دور..."
        (input)="refreshSelectedCard()"
      />
    </span>
    <div class="grow"></div>
    <button
      pButton
      icon="pi pi-plus"
      [label]="'ROLES.NEW_ROLE' | translate"
      (click)="openNew()"
    ></button>
  </div>

  <div class="roles-grid">
    <div
      class="role-card"
      [class.is-superadmin]="r.isSystemSuperAdmin"
      *ngFor="let r of detailRoles; trackBy: trackRole"
    >
      <div class="role-head">
        <div class="role-name-row">
          <span class="role-name">{{ r.name }}</span>
          <span class="superadmin-badge" *ngIf="r.isSystemSuperAdmin" pTooltip="يُدار من صفحة System Owner" tooltipPosition="top">
            <i class="pi pi-shield"></i>
            SuperAdmin
          </span>
        </div>
        <p class="role-desc" *ngIf="r.description">{{ r.description }}</p>
        <p class="role-desc role-desc--muted" *ngIf="!r.description">لا يوجد وصف</p>
      </div>

      <div class="role-stat">
        <i class="pi pi-bolt"></i>
        <span class="role-stat-num">{{ r.actions?.length || 0 }}</span>
        <span class="role-stat-lbl">صلاحية</span>
      </div>

      <div class="role-actions">
        <button
          pButton
          icon="pi pi-shield"
          label="الصلاحيات"
          class="manage-btn"
          (click)="managePermissions(r)"
        ></button>
        <button
          pButton
          icon="pi pi-pencil"
          class="icon-btn"
          pTooltip="تعديل"
          tooltipPosition="top"
          (click)="openEdit(r)"
        ></button>
        <button
          pButton
          icon="pi pi-trash"
          class="icon-btn danger"
          [disabled]="r.isSystemSuperAdmin"
          [pTooltip]="r.isSystemSuperAdmin ? 'تُدار من System Owner' : 'حذف'"
          tooltipPosition="top"
          (click)="remove(r)"
        ></button>
      </div>
    </div>

    <div class="empty-state" *ngIf="detailRoles.length === 0">
      <div class="empty-illust"><i class="pi pi-inbox"></i></div>
      <h3>{{ search ? 'لا توجد نتائج' : 'لا توجد أدوار في هذا النظام' }}</h3>
      <p *ngIf="search">جرّب تعديل البحث أو امسحه.</p>
      <p *ngIf="!search">ابدأ بإضافة دور جديد من الأعلى.</p>
    </div>
  </div>
</ng-container>

<!-- =========================================================
     CREATE / EDIT DIALOG
     ========================================================= -->
<p-dialog [(visible)]="show" [modal]="true" [style]="{ width: '620px' }">
  <ng-template pTemplate="header">
    {{ editId ? 'تعديل دور' : 'دور جديد' }}
  </ng-template>

  <div class="form-grid">
    <div class="col">
      <div class="field">
        <label>الاسم</label>
        <input pInputText [(ngModel)]="form.name" />
      </div>

      <div class="field">
        <label>النظام (اختياري)</label>
        <p-dropdown
          [options]="systems"
          optionLabel="displayName"
          optionValue="key"
          [(ngModel)]="form.systemKey"
          placeholder="Global"
          [showClear]="true"
          styleClass="w-full"
          appendTo="body"
        ></p-dropdown>
      </div>

      <div class="field">
        <label>الوصف</label>
        <input pInputText [(ngModel)]="form.description" />
      </div>
    </div>

    <div class="col">
      <div class="field">
        <label>الصلاحيات</label>
        <p-multiSelect
          [options]="permOptions"
          [(ngModel)]="form.actions"
          display="chip"
          [showToggleAll]="false"
          styleClass="w-full"
          appendTo="body"
        ></p-multiSelect>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      label="إلغاء"
      class="p-button-secondary"
      (click)="show = false"
    ></button>
    <button pButton label="حفظ" icon="pi pi-save" (click)="save()"></button>
  </ng-template>
</p-dialog>
